import { generateLanguageQuery } from '@/services/dataStore/queries/fragments'

export const remedyCategoriesQuery = () =>
  `*[_type == "remedyCategory"] {
    'id': _id,
    'name': ${generateLanguageQuery('name')},
    sortOrder,
    categoryColor,
    'pillColors': {
      'light': {
        'bgColor': pillColors.bgColorLight,
        'textColor': pillColors.textColorLight
      },
      'satellite': {
        'bgColor': pillColors.bgColorSatellite,
        'textColor': pillColors.textColorSatellite
      }
    },
    'footprintStyles': {
      'light': {
        'color': footprintStyles.colorLight,
        'lineColor': footprintStyles.lineColorLight,
        'draggingOpacity': footprintStyles.draggingOpacityLight,
        'placedOpacity': footprintStyles.placedOpacityLight,
        'selectedOpacity': footprintStyles.selectedOpacityLight
      },
      'satellite': {
        'color': footprintStyles.colorSatellite,
        'lineColor': footprintStyles.lineColorSatellite,
        'draggingOpacity': footprintStyles.draggingOpacitySatellite,
        'placedOpacity': footprintStyles.placedOpacitySatellite,
        'selectedOpacity': footprintStyles.selectedOpacitySatellite
      }
    }
  }`
